import Model, { valueWithArray } from 'ducker-model';

// 1.定义property
const property = {
  code: String,
  title: String,
  tags: valueWithArray(String),
  source: String,
  time: String,
};

// 2.定义replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  code: {
    property: 'code',
    defaultValue: '',
  },
  title: {
    property: 'title',
    defaultValue: '--',
  },
  tags: {
    property: 'Data.Tags',
    defaultValue: ['资讯'],
  },
  source: {
    property: 'mediaName',
    defaultValue: '--',
  },
  time: {
    property: 'showTime',
    defaultValue: '--',
  },
};
export default new Model(property, replacedKeyFromPropertyName);
